import DetailPayrollSheet from './views/DetailPayrollSheet.vue'

export const PayrollSheetRoutes = [
  {
    path: '/payroll-sheet/:id/:type/:idPendingProcesses?',
    name: 'DetailPayrollSheet',
    component: DetailPayrollSheet,
    meta: {
      auth: true,
      layout: 'home'
    }
  }
]
